// extracted by mini-css-extract-plugin
export default {"products":"at-z","card":"bt-z","oosMessaging":"ct-z"};